__turbopack_context__.v({
  "container": "Container-module__tDeA-q__container",
});
